import type { MailboxInfo } from "owa-client-types";
import { mutatorAction } from "satcheljs";
import { logStartGreyError } from "owa-analytics-start";
import { getStore } from "../store/store";
import { getAccountSettingsInternal } from "../utils/getAccountSettingsInternal";
import { getOrInitializeSharedMailboxFolderInformationMap } from "../utils/sharedMailboxFolderInformationUtils";
import type DistinguishedFolderIdName from "owa-service/lib/contract/DistinguishedFolderIdName";
import { isUnifiedInboxMailboxInfo } from "owa-client-types/lib/UnifiedInboxMailboxInfo";

const addFolderToDefaultFolderMappingsMutator: (defaultFolderName: DistinguishedFolderIdName, folderId: string, mailboxInfo: MailboxInfo) => void = mutatorAction("ADD_FOLDER_TO_DEFAULT_FOLDER_MAPPINGS", (defaultFolderName: DistinguishedFolderIdName, folderId: string, mailboxInfo: MailboxInfo): void => {
    const store = getStore();
    if (defaultFolderName && folderId) {
        if (mailboxInfo.type == "SharedMailbox") {
            const additionalAccountInformation = getOrInitializeSharedMailboxFolderInformationMap(mailboxInfo);
            if (additionalAccountInformation) {
                additionalAccountInformation.defaultFolderNameToIdMap?.set(defaultFolderName, folderId);
                additionalAccountInformation.defaultFolderIdToNameMap?.set(folderId, defaultFolderName);
                store.sharedMailboxFolderIdToNameMap?.set(folderId, defaultFolderName);
            }
        }
        else {
            const settings = getAccountSettingsInternal(mailboxInfo);
            if (settings) {
                // If mailboxInfo is UnifiedInbox, we do not want to add default folder name to Id mappings
                // so we don't overwrite the existing mappings for the global account, since the name is not unique
                if (!isUnifiedInboxMailboxInfo(mailboxInfo)) {
                    settings.defaultFolderNameToIdMap?.set(defaultFolderName, folderId);
                }
                
                // We can add folderId to name mapping for all mailbox types since folderId is unique
                settings.defaultFolderIdToNameMap?.set(folderId, defaultFolderName);
                store.defaultFolderIdToNameMap?.set(folderId, defaultFolderName);
            }
        }
    }
    else {
        const error = new Error("AddFolderToDefaultFolderMappingsInvalidParameters");
        
        logStartGreyError("AddFolderToDefaultFolderMappingsInvalidParameters", mailboxInfo, error);
    }
});
export default addFolderToDefaultFolderMappingsMutator;
